export const X: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#A1A7BA",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m6 14 8-8M14 14 6 6"
    ></path>
  </svg>
);
